<div
	class="location-tree-filter-container visible-scroll colored-scroll-track nice-scroll"
>
	@if (loadingOptions) {
		<div class="loader-container flex-center-center">
			<mat-spinner diameter="40"></mat-spinner>
		</div>
	}

	@if (!loadingOptions) {
		<au-search-input
			class="m-b-sxs p-l-sm p-r-sm"
			placeholder="{{ 'type_building_name' | translate }}"
			(click)="$event.stopPropagation()"
			(searchTextChanged)="updateFilteredData($event)"
			subscriptSizingMode="dynamic"
		></au-search-input>
		<mat-tree
			[dataSource]="filteredDataSource"
			[treeControl]="treeControl"
			class="filter-container"
		>
			<mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding="{{ node.level }}">
				<button disabled mat-icon-button></button>
				<mat-checkbox
					(change)="locationsSelection.toggle(node)"
					(click)="$event.stopPropagation()"
					[checked]="locationsSelection.isSelected(node)"
					class="checklist-leaf-node au-checkbox"
					color="primary"
					value="{{ node.id }}"
					>{{ node.name }}</mat-checkbox
				>
			</mat-tree-node>
			<mat-tree-node
				*matTreeNodeDef="let node; when: hasChild"
				matTreeNodePadding="{{ node.level }}"
			>
				<button
					[attr.aria-label]="'toggle ' + node.name"
					mat-icon-button
					matTreeNodeToggle
				>
					<mat-icon class="mat-icon-rtl-mirror">
						{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
					</mat-icon>
				</button>
				<mat-checkbox
					(change)="toggleParent(node, $event)"
					(click)="$event.stopPropagation()"
					[checked]="descendantsAllSelected(node)"
					[indeterminate]="descendantsPartiallySelected(node)"
					class="checklist-leaf-node au-checkbox"
					color="primary"
					value="{{ node.id }}"
					>{{ node.name }}</mat-checkbox
				>
			</mat-tree-node>
		</mat-tree>
	}

	<ng-template #noFilterOptions>
		<div class="no-data p-l-sm m-t-sxs m-b-sxs">
			{{ 'no_options_available' | translate }}
		</div>
	</ng-template>
</div>
